export const paletteRed = {
  primary: {
    lighter: '#FFEBEE',
    light: '#E57373',
    main: '#D32F2F', // Red 700 - Primary
    dark: '#C62828',
    darker: '#B71C1C', 
    contrastText: '#ffffff',
  },
  secondary: {
    lighter: '#FFF3E0',
    light: '#FFB74D',
    main: '#F57C00', // Orange 700 - Secondary
    dark: '#E65100',
    contrastText: '#ffffff',
  },
  error: {
    light: '#EF5350',
    main: '#D32F2F',
    dark: '#C62828',
    contrastText: '#fff',
  },
  warning: {
    light: '#FFF9C4',
    main: '#FBC02D',
    dark: '#F57F17',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  success: {
    light: '#C8E6C9',
    main: '#2E7D32',
    dark: '#1B5E20',
    contrastText: '#fff',
  },
  info: {
    main: '#0288D1', 
    light: '#03A9F4', 
    dark: '#01579B', 
    contrastText: '#fff'
  },
  background: {
    default: '#FDFDFD', // Slightly warmer tint
    paper: '#FFFFFF',
    neutral: '#F5F5F5',
  },
  text: {
    primary: '#212121', 
    secondary: '#616161', 
    disabled: '#9E9E9E', 
  },
  divider: '#EEEEEE',
  brand: {
    main: '#B71C1C',
    light: '#FFEBEE',
    lighter: '#FFF3E0',
    dark: '#7f0000',
    contrastText: '#ffffff',
    headerBg: '#D32F2F',     // = primary.main
    headerText: '#ffffff',
    rowHover: '#FFEBEE',
  },
};
